import { Nullable } from '@dai/common'

import {
  AccountSetUpStep,
  IsCompleteProps,
} from '../components/account-set-up/types'

const isStepAfter = (
  stepA: string,
  stepB: string,
  flow: AccountSetUpStep[],
) => {
  const indexA = flow.findIndex(step => step.key === stepA)
  const indexB = flow.findIndex(step => step.key === stepB)
  if (indexA === -1 || indexB === -1) return false
  return indexA > indexB
}

const isValidStep = ({
  stepKey,
  firstIncomplete,
  flow,
  isCompleteProps,
}: {
  stepKey: Nullable<string>
  firstIncomplete: Nullable<AccountSetUpStep>
  flow: AccountSetUpStep[]
  isCompleteProps: IsCompleteProps
}): boolean => {
  if (!stepKey) return false
  const step = flow.find(s => s.key === stepKey)
  if (!step) return false

  return (
    (!step.isComplete(isCompleteProps) || step.canReturnTo) &&
    (!firstIncomplete || !isStepAfter(step.key, firstIncomplete.key, flow))
  )
}

const getFirstIncompleteStep = ({
  flow,
  isCompleteProps,
}: {
  flow: AccountSetUpStep[]
  isCompleteProps: IsCompleteProps
}) => {
  return flow.find(step => !step.isComplete(isCompleteProps))
}

const getCurrentStepIndex = ({
  currentStep,
  flow,
}: {
  currentStep: Nullable<string>
  flow: AccountSetUpStep[]
}) => {
  if (!currentStep) return -1
  return flow.findIndex(step => step.key === currentStep)
}

export const AccountSetUpHelpers = {
  isStepAfter,
  isValidStep,
  getFirstIncompleteStep,
  getCurrentStepIndex,
}
